import React from "react";
import { Container } from "@material-ui/core";
import SignUpForm from "./SignUpForm";
import ImgHeader from "../ImgHeader";
import styled from "styled-components";
import { H1 } from "../Headers";
import ScrollToTopOnMount from "../ScrollToTopOnMount";
import SignUpStepper from "./SignUpStepper";

const SignUpContainer = styled(Container)`
  max-width: 100%;
  width: 100%;
  margin: 0;
  padding: 2em;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
`;

export default function SignUp() {
  return (
    <>
      <ScrollToTopOnMount />
      <ImgHeader url="/static/img/Card-RegisterToExplore.png" shadowOpacity={0.4}>
        <H1>Apply for Partner Portal Access</H1>
      </ImgHeader>
      <SignUpContainer>
        <SignUpStepper />
      </SignUpContainer>
    </>
  );
}
